<template>
  <ion-content fullscreen class="top-safe-space">
    <div class="wraper">
      <div class="is-flex ion-justify-content-end">
        <ion-button fill="clear" @click="save"
          >{{ $t('completeProfile.categoryReminderClose') }}
        </ion-button>
      </div>
      <ion-header class="header">
        <h2 class="title is-5 is-flex-grow-1">
          {{ $t('completeProfile.categoryReminderTitle') }}
        </h2>
        <p class="text">
          {{ $t('completeProfile.categoryReminderMessage') }}
        </p>
      </ion-header>

      <div>
        <h4 class="fw-700 mb-5 uppercase">
          {{ $t('verifyProfile.profession.label') }}
        </h4>
        <UserProfessions
          :professions="$store.getters['profile/getUserProfessions']"
          :fetch-user-professions-fn="
            () => $store.dispatch('profile/setUserProfessions')
          "
          :delete-user-profession-fn="
            (object) => $store.dispatch('profile/removeBignumber', object.id)
          "
          :add-user-profession-fn="
            (object) => $store.dispatch('profile/addBignumber', object)
          "
          :update-user-profession-fn="
            (object) => $store.dispatch('profile/updateBignumber', object)
          "
          can-add-profession
          can-delete-profession
          can-edit-profession
          :show-title="false"
        />

        <template
          v-if="$store.getters['profile/getUserProfessions']?.length > 0"
        >
          <UserCategories
            v-if="$store.getters['profile/getUserProfessions']?.length > 0"
            :user-categories="$store.getters['profile/getUserCategories']"
            :professions="$store.getters['profile/getUserProfessions']"
            :no-categories="$store.getters['profile/getNoCategory']"
            can-add-category
            can-delete-category
            can-edit-category
            :show-title="false"
          />

          <div class="is-flex ion-justify-content-end">
            <ion-button @click="save">{{ $t('commonKeys.save') }}</ion-button>
          </div>
        </template>
      </div>
    </div>
  </ion-content>
</template>

<script setup>
import { modalController, IonHeader, IonContent, IonButton } from '@ionic/vue';
import UserProfessions from '@/components/profile/professions/UserProfessions';
import UserCategories from '@/components/profile/professions/UserCategories';
import { useStore } from 'vuex';

const store = useStore();
function save() {
  modalController.dismiss();
  store.dispatch('profile/setProfileDetails');
}
</script>

<style lang="scss" scoped>
.wraper {
  padding: 20px !important;
  border-radius: 10px;
}
.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  .title {
    font-size: 24px;
    margin: 10px 10px 30px;
  }
  .text {
    font-size: 16px;
    text-align: center;
    text-wrap: balance;
  }
}
</style>
